import Cookies from 'js-cookie';

export default {
  get: () => {
    return Cookies.get('contribute');
  },
  set: (value) => {
    Cookies.set('contribute', value, { expires: 365 });
  }
};
